import { useTranslation } from 'react-i18next'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'

interface IProps {
  close: () => void
}

const PendingActivities = ({ close }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'lessons.modals.pendingActivities'

  return (
    <Modal
      title={t(`${translationPrefix}.title`)}
      isConfirmation
      close={close}
      actions={
        <ModalButtons
          secondaryText={t(`${translationPrefix}.action`)}
          secondaryAction={close}
          secondaryIsPrimary
        />
      }
      maxwidth={800}
      maxheight={180}
    >
      {`${t(`${translationPrefix}.content`)}`}
    </Modal>
  )
}

export default PendingActivities
